import { Injectable } from '@angular/core';
import { Service } from '../models/service';
import { ApiService } from '../../services/api.service';
import { BehaviorSubject, Observable } from 'rxjs/index';
import { LoadingService } from '../../services/loading.service';
import { NotificationsService } from '../../services/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NotificationType } from '../../models/notification';

interface ServicesResponse {
  data: Service[];
}

interface ServiceResponse {
  data: Service;
}

@Injectable()
export class ServiceService {
  public service: Observable<Service>;
  private service$: BehaviorSubject<Service>;
  public services: Observable<Service[]>;
  private services$: BehaviorSubject<Service[]>;
  private message: string;

  constructor(
    private apiService: ApiService,
    private route: Router,
    private loadingService: LoadingService,
    private notificationService: NotificationsService,
    private translateService: TranslateService
  ) {
    this.service$ = new BehaviorSubject(new Service());
    this.service = this.service$.asObservable();
    this.service.subscribe();
    this.services$ = new BehaviorSubject([]);
    this.services = this.services$.asObservable();
    this.services.subscribe();
    translateService.get('general.form.error').subscribe((res: string) => {
      this.message = res;
    });
  }
  private displayNotification(type, messageCode?: string) {
    let message: string;
    if (messageCode === undefined) {
      messageCode = 'api.general.error';
    }
    this.translateService.get(messageCode).subscribe((res: string) => {
      message = res;
    });
    this.loadingService.hide();
    if (type === NotificationType.Error) {
      this.notificationService.error(message);
    }
    if (type === NotificationType.Success) {
      this.notificationService.success(message);
    }
  }

  public getServices() {
    return this.apiService.post('/components/application/get').subscribe((response: ServicesResponse) => {
      this.services$.next(response.data);
      this.loadingService.hide();
    }, (error) => {
      this.displayNotification(NotificationType.Error);
    });
  }

  public getService(id) {
    return this.apiService.post('/components/application/get-one',
      { body: { 'id': id } }
    ).subscribe((response: ServiceResponse) => {
      this.service$.next(response.data);
      this.loadingService.hide();
    }, (error) => {
      this.loadingService.hide();
      this.notificationService.error(this.message);
    });
  }

  public save(service: Service) {
    return this.apiService.post(
      '/components/application/create',
      { body: service }
    ).subscribe((response) => {
      this.route.navigate(['/services']);
      this.displayNotification(NotificationType.Success, 'service.actions.add.success');
    }, (error) => {
      this.displayNotification(NotificationType.Error, 'service.actions.add.error');
    });
  }

  public update(service: Service, serviceForm: Service) {
    this.apiService.post(
      '/components/application/update',
      { body: serviceForm }
    ).subscribe((response) => {
      this.translateService.get('service.actions.edit.success').subscribe((res: string) => {
        this.message = res;
      });
      this.loadingService.hide();
      this.notificationService.success(this.message);
      this.route.navigate(['/services']);
    }, (error) => {
      this.loadingService.hide();
      this.notificationService.error(this.message);
    });
  }

  public delete(id) {
    return this.apiService.post('/components/application/delete',
      { body: { 'id': id } }
    ).subscribe((response) => {
      this.getServices();
      this.displayNotification(NotificationType.Success, 'service.actions.delete.success');
    }, (error) => {
      this.displayNotification(NotificationType.Error, 'service.actions.delete.error');
    });
  }
}
